import React from 'react';
import {getRowDataForColumnComponent} from 'js/common/griddle_column_helper';

const BrandCampaign = campaignExecutionUrl => props => {
    const {campaign_id, campaign_name, brand_name} = getRowDataForColumnComponent(props);
    return (
        <div>
            <div>
                <b>{brand_name}</b>
            </div>
            <div>
                <a
                    href={campaignExecutionUrl.replace('__ID__', campaign_id)}
                    title={campaign_name}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {campaign_name}
                </a>
            </div>
        </div>
    );
};

export default BrandCampaign;



// WEBPACK FOOTER //
// ./admin_operations/shipping/components/brand_campaign.js